import(/* webpackMode: "eager", webpackExports: ["CtaTracker"] */ "/opt/buildhome/repo/components/analytics/CtaTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LazyFeaturedGallery"] */ "/opt/buildhome/repo/components/LazyFeaturedGallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductCarouselClient"] */ "/opt/buildhome/repo/components/products/carousel/ProductCarouselClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReviewAvatar"] */ "/opt/buildhome/repo/components/reviews/ReviewAvatar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReviewCarousel"] */ "/opt/buildhome/repo/components/reviews/ReviewCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Separator"] */ "/opt/buildhome/repo/components/ui/separator.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/image-component.js");
